.footer_footerContainer__jqe1l10 {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  max-width: 1604px;
  margin: 0 auto;
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  margin-top: 14px;
  padding: 20px;
  align-items: start;
}
.footer_linksContainer__jqe1l11 {
  display: grid;
  row-gap: 10px;
  grid-template-columns: repeat(2, min-content);
  column-gap: 20px;
}
.footer_footerLink__jqe1l12 {
  color: inherit;
}
.footer_footerLink__jqe1l12:hover {
  text-decoration: underline;
}
.footer_linksContainer__jqe1l11 > a {
  white-space: nowrap;
}
@media screen and (min-width: 768px) {
  .footer_footerContainer__jqe1l10 {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    margin-top: 40px;
    padding: 20px 60px;
    align-items: center;
  }
  .footer_linksContainer__jqe1l11 {
    grid-template-columns: repeat(4, min-content);
    column-gap: 32px;
  }
}